import { Component, OnInit } from '@angular/core';
import { Routes, Router, ActivatedRoute } from '@angular/router';

import { AuthenticationService } from '../../../auth/index';

import { UbiMenuService } from '../../services';
import { PAGES_MENU } from '../../../app.menu';
import { GlobalState } from '../../../global.state';

declare var require: any;

@Component({
    moduleId: module.id,
    templateUrl: 'ubiLogin.component.html'
})

export class UbiLoginComponent implements OnInit {
    model: any = {};
    loading = false;
    returnUrl: string;
    errorMessage: string = null;

    private appVersion: string = require('../../../../../package.json').version;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private state: GlobalState,
        private authenticationService: AuthenticationService,
        private menuService: UbiMenuService) { }

    ngOnInit() {
        // reset login status
        this.authenticationService.logout();

        this.state.notifyDataChanged('submenu.activeLink', 'Login');
        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    }

    login() {
        this.loading = true;
        this.errorMessage = null;
        this.authenticationService.login(this.model.username, this.model.password)
            .subscribe(
                data => {
                    this.menuService.updateMenuByRoutes(<Routes>PAGES_MENU);
                    this.router.navigate([this.returnUrl]);
                },
                error => {
                    this.errorMessage = 'Não foi possível efectuar a autenticação, verifique as credenciais.';
                    this.loading = false;
                });
    }
}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/components/ubiLogin/ubilogin.component.ts